export default () => ({
	error: false,
	errors: [],
	sending: false,
	success: false,
	submission: [],
	sendForm: async function() {
		this.sending = true

		// Get a token and set it.
		const token = await getToken()
		document.querySelectorAll('form input[name="_token"]').forEach(function(item) {
			item.value = token
		});

		// Post the form.
		fetch(this.$refs.form.action, {
			headers: {
				'X-Requested-With' : 'XMLHttpRequest',
			},
			method: 'POST',
			body: new FormData(this.$refs.form)})
		.then(res => res.json())
		.then(json => {
			console.log(json)
			if (json['success']) {
				this.errors = []
				this.success = true
				this.error = false
				this.sending = false
				this.submission = json['submission']
				this.$refs.form.reset()
				setTimeout(function(){
					this.success = false
				}, 4500)

				// fire off GA Event:
				window.GAEvent('Forms', 'enquiry', 'Product Enquiry');
			}
			if (json['error']) {
				this.sending = false
				this.error = true
				this.success = false
				this.errors = json['error']
			}
		})
		.catch(err => {
			err.text().then( errorMessage => {
				this.sending = false
			})
		})
	}
})
